import React from 'react'
import { useSelector } from 'react-redux'

import CheckboxListFilter, {
  type CheckboxListFilterProps,
} from '~/components/common/filters/CheckboxListFilter'
import { getInventoryOrderShipmentStatus } from '~/store/reducers/constants'

export interface InventoryOrderStatusFilterProps
  extends CheckboxListFilterProps {}

const InventoryOrderStatusFilter = (props: InventoryOrderStatusFilterProps) => {
  const InventoryOrderStatuses = useSelector(getInventoryOrderShipmentStatus)

  return <CheckboxListFilter items={InventoryOrderStatuses} {...props} />
}

export default InventoryOrderStatusFilter
